module.exports = __webpack_public_path__ + "img/map.592066c9.png";